import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CaseDetailsService } from '../../home/case-details/case-details.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input() expanded: boolean = true;
  constructor(
    private router: Router,
    private caseDetailsService: CaseDetailsService,
    private toast: ToastrService
  ) { }
  menuList: any[] = [
    {
      route: 'dashboard',
      img: 'assets/icons/Graph.png',
      title: 'Dashboard',
    },
    {
      route: 'sla/instances',
      img: 'assets/icons/Graph.png',
      title: 'SLA Instances',
    },
    {
      route: 'sla/config',
      img: 'assets/icons/carbon_settings.png',
      title: 'SLA Configuration',
    },
    {
      route: 'KYC',
      img: 'assets/icons/Kyc.png',
      title: 'KYC',
    },
    {
      route: 'users',
      img: 'assets/icons/profile-circle.png',
      title: 'Accounts',
    },
    {
      route: 'landing-list/MOD004',
      img: 'assets/icons/alert.png',
      title: 'Alert',
    },
    {
      route: 'On demand',
      img: 'assets/icons/On demand.png',
      title: 'One Demand Screening',
    },
    {
      route: 'landing-list/MOD005',
      img: 'assets/icons/Inquiries.png',
      title: 'Inquiry',
    },
    {
      route: 'landing-list/MOD006',
      img: 'assets/icons/message-alert.png',
      title: 'Task',
    },
    {
      route: 'FATCA',
      img: 'assets/icons/FATCA.png',
      title: 'System Report',
    },
    {
      route: 'Regulatory Report',
      img: 'assets/icons/Regulatory Report.png',
      title: 'Regualatory Report',
    },
    {
      route: 'FATCA',
      img: 'assets/icons/FATCA.png',
      title: 'FATCA Reportin',
    },
    {
      route: 'Analytics',
      img: 'assets/icons/Analytics.png',
      title: 'Analaystic',
    },
    {
      route: 'Audit Trail',
      img: 'assets/icons/Audit Trail.png',
      title: 'Audit Trail',
    },
    // {
    //   route: 'landing-list/MOD003',
    //   img: 'assets/icons/Workflow.png',
    //   title: 'Work Flow',
    // },
    {
      route: 'workflow-builder',
      img: 'assets/icons/Workflow.png',
      title: 'Work Flow  Builder',
    },
    {
      route: 'landing-list/MOD001',
      img: 'assets/icons/rule-manage.png',
      title: 'Case Management',
    },

    {
      route: 'landing-list/MOD002',
      img: 'assets/icons/rule-manage.png',
      title: 'Rule Management',
    },
    {
      route: 'user',
      img: 'assets/icons/user.png',
      title: 'User Management',
    },
    {
      route: 'carbon_settings',
      img: 'assets/icons/carbon_settings.png',
      title: 'Configuration',
    },
    {
      route: 'Watchlist',
      img: 'assets/icons/Watchlist.png',
      title: 'Watching Managment List',
    },
    {
      route: 'assignment/rules',
      img: 'assets/icons/rule-manage.png',
      title: 'Assignment Rules',
    },
    {
      route: 'availability/vacation',
      img: 'assets/icons/profile-circle.png',
      title: 'My Vacation',
    },
    {
      route: 'availability/organization',
      img: 'assets/icons/Watchlist.png', // Reusing icon for now
      title: 'Org Holidays',
    },
    {
      route: '',
      img: 'assets/icons/Watchlist.png',
      title: 'Reports',
      subMenu: [
      ]
    },
  ];
  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }
  ngOnInit(): void {
    this.getMenuList();
    this.syncActiveState();
  }

  syncActiveState() {
    const currentUrl = this.router.url;
    this.menuList.forEach(menu => {
      // Check if current URL contains the menu route to handle active state
      if (menu.route && currentUrl.includes(menu.route)) {
        menu.isActive = true;
      } else {
        menu.isActive = false;
      }
    });
  }

  getMenuList() {
    this.caseDetailsService.caseStatusEdit('REPORT_MENU').subscribe(
      (data) => {
        let reportMainRoute = this.menuList?.find((item: any) => item.title === 'Reports');
        if (reportMainRoute) {
          reportMainRoute.subMenu = data?.data.map((item: any) => {
            return {
              route: item.value,
              title: item.valueDesc,
              isActive: false
            };
          });
        }
      },
      (error: any) => {
        this.toast.error(error.error);
      }
    );
  }
  activateRoute(menu: any) {
    menu.isActive = true;
    this.menuList.forEach((item: any) => {
      if (item.title !== menu.title) {
        item.isActive = false;
      }
    });
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/' + menu.route]);
    });
  }
}
